// extracted by mini-css-extract-plugin
export default {"FrameworkEvidenceDescription":"styles_FrameworkEvidenceDescription__xETNb","FrameworkControlDescription":"styles_FrameworkControlDescription__kv23p"};